"use client";

/**
 * Ou atterrit-on apres s'etre connecte ?
 *
 * Le cas particulier : une agence RATTACHEE a un reseau (membre actif, pas
 * siege) sans aucune adresse enregistree. Ses prestations partent sur la facture
 * mensuelle du siege, et une facture a besoin d'une adresse. La laisser arriver
 * sur son compte, c'est decouvrir le probleme au moment de facturer, quand il
 * est trop tard pour le mois.
 *
 * TROIS garde-fous, parce qu'une redirection ratee vaut pire qu'une absence de
 * redirection :
 *  - Les comptes non Pro ne demandent RIEN au serveur. Un voyageur ordinaire ne
 *    peut pas etre membre d'un reseau ; lui coûter deux requetes a chaque
 *    connexion pour une reponse connue d'avance serait absurde.
 *  - Un echec, quel qu'il soit, rend la destination habituelle. Une lecture
 *    indisponible ne doit jamais retenir quelqu'un sur une page qu'il n'a pas
 *    demandee.
 *  - Le parcours de reservation n'arrive jamais ici : il a sa propre
 *    destination, et detourner un client en train de payer serait le pire
 *    moment choisi.
 */

import api from "@/app/lib/reducers/api";

/** La destination ordinaire : role 3 = guide, il a son propre tableau de bord. */
export const defaultRouteFor = (user: any): string =>
  user?.role === 3 ? "/guide-missions" : "/account";

export const resolvePostLoginRoute = async (user: any): Promise<string> => {
  const fallback = defaultRouteFor(user);
  if (!user?.uuid) return fallback;
  // Un membre de reseau est forcement Pro, et un siege n'est le enfant de
  // personne : ces deux tests evitent l'aller-retour dans tous les autres cas.
  if (user?.isPro !== true || user?.isHeadOffice === true) return fallback;

  try {
    const { data } = await api.get("/api/network");
    // `membership` n'est servi que pour une adhesion ACTIVE — une invitation en
    // attente n'en est pas une, et ne doit rien declencher.
    const isChild = data?.isHeadOffice !== true && !!data?.membership;
    if (!isChild) return fallback;

    const { data: addresses } = await api.get(`/api/user/${user.uuid}/addresses`);
    const hasAddress = Array.isArray(addresses) && addresses.length > 0;
    // `setup=1` sert uniquement a expliquer la redirection sur place. Sans lui,
    // on atterrit sur un ecran d'adresses sans savoir pourquoi.
    return hasAddress ? fallback : "/my-addresses?setup=1";
  } catch {
    return fallback;
  }
};

export default resolvePostLoginRoute;
